export const allCountries = [
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brazil", code: "BR" },
  { name: "Brunei", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cabo Verde", code: "CV" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "East Timor", code: "TL" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Eswatini", code: "SZ" },
  { name: "Ethiopia", code: "ET" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Greece", code: "GR" },
  { name: "Grenada", code: "GD" },
  { name: "Guatemala", code: "GT" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Honduras", code: "HN" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Ireland", code: "IE" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, South", code: "KR" },
  { name: "Kosovo", code: "XK" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Laos", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia", code: "FM" },
  { name: "Moldova", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "North Macedonia", code: "MK" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestine", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Qatar", code: "QA" },
  { name: "Romania", code: "RO" },
  { name: "Russia", code: "RU" },
  { name: "Rwanda", code: "RW" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Sudan", code: "SS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Taiwan", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Togo", code: "TG" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Vatican City", code: "VA" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];


export const postalCodePatterns = {
  GB: {
    pattern: /^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4})$/i,
    example: "SW1A 1AA or M1 1AA"
  },
  JE: {
    pattern: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/i,
    example: "JE2 3AB"
  },
  GG: {
    pattern: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/i,
    example: "GY1 1AA"
  },
  IM: {
    pattern: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/i,
    example: "IM1 1AA"
  },
  US: {
    pattern: /^\d{5}([ \-]\d{4})?$/,
    example: "12345 or 12345-6789"
  },
  CA: {
    pattern: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    example: "K1A 0A6"
  },
  DE: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  JP: {
    pattern: /^\d{3}-\d{4}$/,
    example: "123-4567"
  },
  FR: {
    pattern: /^\d{2}[ ]?\d{3}$/,
    example: "75012"
  },
  AU: {
    pattern: /^\d{4}$/,
    example: "2000"
  },
  IT: {
    pattern: /^\d{5}$/,
    example: "00118"
  },
  CH: {
    pattern: /^\d{4}$/,
    example: "8001"
  },
  AT: {
    pattern: /^\d{4}$/,
    example: "1010"
  },
  ES: {
    pattern: /^\d{5}$/,
    example: "28001"
  },
  NL: {
    pattern: /^\d{4}[ ]?[A-Z]{2}$/i,
    example: "1234 AB"
  },
  BE: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  DK: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  SE: {
    pattern: /^\d{3}[ ]?\d{2}$/,
    example: "100 05"
  },
  NO: {
    pattern: /^\d{4}$/,
    example: "0001"
  },
  BR: {
    pattern: /^\d{5}[\-]?\d{3}$/,
    example: "01234-567"
  },
  PT: {
    pattern: /^\d{4}([\-]\d{3})?$/,
    example: "1000-001"
  },
  FI: {
    pattern: /^\d{5}$/,
    example: "00100"
  },
  AX: {
    pattern: /^22\d{3}$/,
    example: "22100"
  },
  KR: {
    pattern: /^\d{3}[\-]\d{3}$/,
    example: "123-456"
  },
  CN: {
    pattern: /^\d{6}$/,
    example: "100000"
  },
  TW: {
    pattern: /^\d{3}(\d{2})?$/,
    example: "100 or 10012"
  },
  SG: {
    pattern: /^\d{6}$/,
    example: "123456"
  },
  DZ: {
    pattern: /^\d{5}$/,
    example: "16000"
  },
  AD: {
    pattern: /^AD\d{3}$/,
    example: "AD100"
  },
  AR: {
    pattern: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/i,
    example: "C1000AAA"
  },
  AM: {
    pattern: /^(37)?\d{4}$/,
    example: "0010"
  },
  AZ: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  BH: {
    pattern: /^((1[0-2]|[2-9])\d{2})?$/,
    example: "317 (optional)"
  },
  BD: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  BB: {
    pattern: /^(BB\d{5})?$/,
    example: "BB11000 (optional)"
  },
  BY: {
    pattern: /^\d{6}$/,
    example: "220050"
  },
  BM: {
    pattern: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/i,
    example: "HM 12"
  },
  BA: {
    pattern: /^\d{5}$/,
    example: "71000"
  },
  IO: {
    pattern: /^BBND 1ZZ$/,
    example: "BBND 1ZZ"
  },
  BN: {
    pattern: /^[A-Z]{2}[ ]?\d{4}$/i,
    example: "BE1234"
  },
  BG: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  KH: {
    pattern: /^\d{5}$/,
    example: "12000"
  },
  CV: {
    pattern: /^\d{4}$/,
    example: "7600"
  },
  CL: {
    pattern: /^\d{7}$/,
    example: "8320000"
  },
  CR: {
    pattern: /^\d{4,5}|\d{3}-\d{4}$/,
    example: "1000 or 123-4567"
  },
  HR: {
    pattern: /^\d{5}$/,
    example: "10000"
  },
  CY: {
    pattern: /^\d{4}$/,
    example: "1066"
  },
  CZ: {
    pattern: /^\d{3}[ ]?\d{2}$/,
    example: "100 00"
  },
  DO: {
    pattern: /^\d{5}$/,
    example: "10101"
  },
  EC: {
    pattern: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/i,
    example: "EC170150 (optional)"
  },
  EG: {
    pattern: /^\d{5}$/,
    example: "11511"
  },
  EE: {
    pattern: /^\d{5}$/,
    example: "10101"
  },
  FO: {
    pattern: /^\d{3}$/,
    example: "100"
  },
  GE: {
    pattern: /^\d{4}$/,
    example: "0101"
  },
  GR: {
    pattern: /^\d{3}[ ]?\d{2}$/,
    example: "104 42"
  },
  GL: {
    pattern: /^39\d{2}$/,
    example: "3900"
  },
  GT: {
    pattern: /^\d{5}$/,
    example: "01001"
  },
  HT: {
    pattern: /^\d{4}$/,
    example: "6110"
  },
  HN: {
    pattern: /^(?:\d{5})?$/,
    example: "11101 (optional)"
  },
  HU: {
    pattern: /^\d{4}$/,
    example: "1011"
  },
  IS: {
    pattern: /^\d{3}$/,
    example: "101"
  },
  IN: {
    pattern: /^\d{6}$/,
    example: "110001"
  },
  ID: {
    pattern: /^\d{5}$/,
    example: "40115"
  },
  IL: {
    pattern: /^\d{5}$/,
    example: "91999"
  },
  JO: {
    pattern: /^\d{5}$/,
    example: "11183"
  },
  KZ: {
    pattern: /^\d{6}$/,
    example: "050000"
  },
  KE: {
    pattern: /^\d{5}$/,
    example: "20100"
  },
  KW: {
    pattern: /^\d{5}$/,
    example: "13001"
  },
  LA: {
    pattern: /^\d{5}$/,
    example: "01000"
  },
  LV: {
    pattern: /^\d{4}$/,
    example: "1010"
  },
  LB: {
    pattern: /^(\d{4}([ ]?\d{4})?)?$/,
    example: "1107 2810 (optional)"
  },
  LI: {
    pattern: /^(948[5-9])|(949[0-7])$/,
    example: "9485"
  },
  LT: {
    pattern: /^\d{5}$/,
    example: "01513"
  },
  LU: {
    pattern: /^\d{4}$/,
    example: "1234"
  },
  MK: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  MY: {
    pattern: /^\d{5}$/,
    example: "50754"
  },
  MV: {
    pattern: /^\d{5}$/,
    example: "20026"
  },
  MT: {
    pattern: /^[A-Z]{3}[ ]?\d{2,4}$/i,
    example: "VLT 1117"
  },
  MU: {
    pattern: /^(\d{3}[A-Z]{2}\d{3})?$/i,
    example: "42602 (optional)"
  },
  MX: {
    pattern: /^\d{5}$/,
    example: "01000"
  },
  MD: {
    pattern: /^\d{4}$/,
    example: "2012"
  },
  MC: {
    pattern: /^980\d{2}$/,
    example: "98000"
  },
  MA: {
    pattern: /^\d{5}$/,
    example: "10000"
  },
  NP: {
    pattern: /^\d{5}$/,
    example: "44600"
  },
  NZ: {
    pattern: /^\d{4}$/,
    example: "6001"
  },
  NI: {
    pattern: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
    example: "12345 (optional)"
  },
  NG: {
    pattern: /^(\d{6})?$/,
    example: "100001 (optional)"
  },
  OM: {
    pattern: /^(PC )?\d{3}$/,
    example: "PC 112"
  },
  PK: {
    pattern: /^\d{5}$/,
    example: "44000"
  },
  PY: {
    pattern: /^\d{4}$/,
    example: "1536"
  },
  PH: {
    pattern: /^\d{4}$/,
    example: "1008"
  },
  PL: {
    pattern: /^\d{2}-\d{3}$/,
    example: "00-950"
  },
  PR: {
    pattern: /^00[679]\d{2}([ \-]\d{4})?$/,
    example: "00901"
  },
  RO: {
    pattern: /^\d{6}$/,
    example: "010041"
  },
  RU: {
    pattern: /^\d{6}$/,
    example: "101000"
  },
  SM: {
    pattern: /^4789\d$/,
    example: "47890"
  },
  SA: {
    pattern: /^\d{5}$/,
    example: "11564"
  },
  SN: {
    pattern: /^\d{5}$/,
    example: "12500"
  },
  SK: {
    pattern: /^\d{3}[ ]?\d{2}$/,
    example: "010 01"
  },
  SI: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  ZA: {
    pattern: /^\d{4}$/,
    example: "0001"
  },
  LK: {
    pattern: /^\d{5}$/,
    example: "00100"
  },
  TJ: {
    pattern: /^\d{6}$/,
    example: "734025"
  },
  TH: {
    pattern: /^\d{5}$/,
    example: "10100"
  },
  TN: {
    pattern: /^\d{4}$/,
    example: "1008"
  },
  TR: {
    pattern: /^\d{5}$/,
    example: "06101"
  },
  TM: {
    pattern: /^\d{6}$/,
    example: "744000"
  },
  UA: {
    pattern: /^\d{5}$/,
    example: "01001"
  },
  UY: {
    pattern: /^\d{5}$/,
    example: "11000"
  },
  UZ: {
    pattern: /^\d{6}$/,
    example: "100001"
  },
  VA: {
    pattern: /^00120$/,
    example: "00120"
  },
  VE: {
    pattern: /^\d{4}$/,
    example: "1010"
  },
  ZM: {
    pattern: /^\d{5}$/,
    example: "10101"
  },
  AS: {
    pattern: /^96799$/,
    example: "96799"
  },
  CC: {
    pattern: /^6799$/,
    example: "6799"
  },
  CK: {
    pattern: /^\d{4}$/,
    example: "0000"
  },
  RS: {
    pattern: /^\d{6}$/,
    example: "106314"
  },
  ME: {
    pattern: /^8\d{4}$/,
    example: "81000"
  },
  CS: {
    pattern: /^\d{5}$/,
    example: "11000"
  },
  YU: {
    pattern: /^\d{5}$/,
    example: "11000"
  },
  CX: {
    pattern: /^6798$/,
    example: "6798"
  },
  ET: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  FK: {
    pattern: /^FIQQ 1ZZ$/,
    example: "FIQQ 1ZZ"
  },
  NF: {
    pattern: /^2899$/,
    example: "2899"
  },
  FM: {
    pattern: /^(9694[1-4])([ \-]\d{4})?$/,
    example: "96941"
  },
  GF: {
    pattern: /^9[78]3\d{2}$/,
    example: "97300"
  },
  GN: {
    pattern: /^\d{3}$/,
    example: "001"
  },
  GP: {
    pattern: /^9[78][01]\d{2}$/,
    example: "97100"
  },
  GS: {
    pattern: /^SIQQ 1ZZ$/,
    example: "SIQQ 1ZZ"
  },
  GU: {
    pattern: /^969[123]\d([ \-]\d{4})?$/,
    example: "96910"
  },
  GW: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  HM: {
    pattern: /^\d{4}$/,
    example: "7050"
  },
  IQ: {
    pattern: /^\d{5}$/,
    example: "10001"
  },
  KG: {
    pattern: /^\d{6}$/,
    example: "720001"
  },
  LR: {
    pattern: /^\d{4}$/,
    example: "1000"
  },
  LS: {
    pattern: /^\d{3}$/,
    example: "100"
  },
  MG: {
    pattern: /^\d{3}$/,
    example: "101"
  },
  MH: {
    pattern: /^969[67]\d([ \-]\d{4})?$/,
    example: "96960"
  },
  MN: {
    pattern: /^\d{6}$/,
    example: "210351"
  },
  MP: {
    pattern: /^9695[012]([ \-]\d{4})?$/,
    example: "96950"
  },
  MQ: {
    pattern: /^9[78]2\d{2}$/,
    example: "97200"
  },
  NC: {
    pattern: /^988\d{2}$/,
    example: "98800"
  },
  NE: {
    pattern: /^\d{4}$/,
    example: "8001"
  },
  VI: {
    pattern: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
    example: "00801"
  },
  PF: {
    pattern: /^987\d{2}$/,
    example: "98700"
  },
  PG: {
    pattern: /^\d{3}$/,
    example: "111"
  },
  PM: {
    pattern: /^9[78]5\d{2}$/,
    example: "97500"
  },
  PN: {
    pattern: /^PCRN 1ZZ$/,
    example: "PCRN 1ZZ"
  },
  PW: {
    pattern: /^96940$/,
    example: "96940"
  },
  RE: {
    pattern: /^9[78]4\d{2}$/,
    example: "97400"
  },
  SH: {
    pattern: /^(ASCN|STHL) 1ZZ$/,
    example: "STHL 1ZZ"
  },
  SJ: {
    pattern: /^\d{4}$/,
    example: "9170"
  },
  SO: {
    pattern: /^\d{5}$/,
    example: "JH 09010"
  },
  SZ: {
    pattern: /^[HLMS]\d{3}$/i,
    example: "H100"
  },
  TC: {
    pattern: /^TKCA 1ZZ$/,
    example: "TKCA 1ZZ"
  },
  WF: {
    pattern: /^986\d{2}$/,
    example: "98600"
  },
  XK: {
    pattern: /^\d{5}$/,
    example: "10000"
  },
  YT: {
    pattern: /^976\d{2}$/,
    example: "97600"
  },
  // Additional countries postal patterns following best practices
  AL: {
    pattern: /^\d{4}$/,
    example: "1001"
  },
  AO: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Luanda"
  },
  AG: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "St Johns"
  },
  BS: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Nassau"
  },
  BZ: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Belize City"
  },
  BJ: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Cotonou"
  },
  BT: {
    pattern: /^\d{5}$/,
    example: "11001"
  },
  BO: {
    pattern: /^\d{4}$/,
    example: "1234"
  },
  BW: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Gaborone"
  },
  BF: {
    pattern: /^\d{2}$/,
    example: "01"
  },
  BI: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Bujumbura"
  },
  CM: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Yaounde"
  },
  CF: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Bangui"
  },
  TD: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  CO: {
    pattern: /^\d{6}$/,
    example: "110111"
  },
  KM: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Moroni"
  },
  CG: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Brazzaville"
  },
  DJ: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  DM: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Roseau"
  },
  TL: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Dili"
  },
  SV: {
    pattern: /^\d{4}$/,
    example: "1101"
  },
  GQ: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Malabo"
  },
  ER: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Asmara"
  },
  FJ: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Suva"
  },
  GA: {
    pattern: /^\d{4}$/,
    example: "1234"
  },
  GM: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Banjul"
  },
  GH: {
    pattern: /^[A-Z]{2}\d{7}$/i,
    example: "GA1234567"
  },
  GD: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "St Georges"
  },
  GY: {
    pattern: /^\d{6}$/,
    example: "123456"
  },
  IE: {
    pattern: /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$/i,
    example: "D02 XY45"
  },
  JM: {
    pattern: /^JM[A-Z]{3}\d{2}$/i,
    example: "JMAKN12"
  },
  KI: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Tarawa"
  },
  MW: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Lilongwe"
  },
  ML: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  MR: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  MZ: {
    pattern: /^\d{4}$/,
    example: "1100"
  },
  NA: {
    pattern: /^\d{5}$/,
    example: "10001"
  },
  NR: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Yaren"
  },
  PS: {
    pattern: /^\d{3}$/,
    example: "123"
  },
  PA: {
    pattern: /^\d{4}$/,
    example: "0801"
  },
  PE: {
    pattern: /^\d{5}$/,
    example: "15001"
  },
  QA: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  RW: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Kigali"
  },
  KN: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Basseterre"
  },
  LC: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Castries"
  },
  VC: {
    pattern: /^VC\d{4}$/i,
    example: "VC0100"
  },
  WS: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Apia"
  },
  ST: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Sao Tome"
  },
  SC: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Victoria"
  },
  SL: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Freetown"
  },
  SB: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Honiara"
  },
  SS: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  SD: {
    pattern: /^\d{5}$/,
    example: "11111"
  },
  SR: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Paramaribo"
  },
  TZ: {
    pattern: /^\d{4,5}$/,
    example: "11101"
  },
  TG: {
    pattern: /^\d{4}$/,
    example: "1234"
  },
  TO: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Nukualofa"
  },
  TT: {
    pattern: /^\d{6}$/,
    example: "110101"
  },
  TV: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Funafuti"
  },
  UG: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Kampala"
  },
  AE: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  VU: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Port Vila"
  },
  VN: {
    pattern: /^\d{6}$/,
    example: "100000"
  },
  YE: {
    pattern: /^\d{5}$/,
    example: "12345"
  },
  ZW: {
    pattern: /^[\w\s\-]{2,10}$/,
    example: "Harare"
  },
  // Add default pattern for any unlisted countries
  default: {
    pattern: /^[\w\s\-]{2,10}$/i,
    example: "Enter postal code"
  }
};